/* global swal */
import LoaderPopup from '../../shared/libs/LoaderPopup';
import hiddenFooter from '../../shared/mixins/hidden_footer';
import googleTagManager from '../../shared/mixins/google_tag_manager';
import axios from 'axios';

export default {
  template: '#auth-login',
  props: ['hExcludeFacebook'],
  data() {
    return {
      user: {
        remember_me: 1,
        email: '',
        password: ''
      },
      from_axios: true
    }
  },
  computed: {},
  mounted() {

    $('html, body').animate({scrollTop: 0}, 250);
  },
  methods: {
    getAccess(e) {
      LoaderPopup.show();
      googleTagManager.methods.triggerFromLogin(window.location.href);
      $('.js-submit-login').prop('disabled', true);
      axios.post(e.target.action, this.$data, {
        headers: {
          'Content-Type': 'application/json',
          responseType: 'json'
        }
      })
        .then(response => {
          $('.js-submit-login').prop('disabled', false);
          LoaderPopup.hide();
          window.location.href = response.data.redirect;
        })
        .catch(errors => {
          LoaderPopup.hide();
          $('.js-submit-login').prop('disabled', false);
          swal('¡Ha ocurrido un error!', errors.response.data.message, 'error');
        })
    }
  },
  mixins: [hiddenFooter, googleTagManager]
}